<template class="p-8 bg-primary-700">
  <h-progressor class="bg-white" :steps="stepData" />
</template>

<script>
import axios from "axios";
import { wait } from "../../../../../resources/js/helpers/functions_helpers.js";
import { EventBus } from "../../../../../resources/js/hermeneus.eventbus/eventbus.js";
import UebungActivitasCreateIntroduction from "./UebungActivitasCreateIntroduction.vue";
import LemmaComposer from "@js/lemma-composer/LemmaComposer.vue";
import UebungActivitasCreateConfig from "./UebungActivitasCreateConfig.vue";
import UebungActivitasCreateSubmit from "./UebungActivitasCreateSubmit.vue";
import { markRaw } from "vue";
import { useUebungActivitasCreateStore } from "./stores/uebungActivitasCreateStore";

export default {
  name: "uebung-activitas-create-component",
  props: [],
  components: {
    UebungActivitasCreateIntroduction,
    LemmaComposer
  },
  data() {
    return {
      store: useUebungActivitasCreateStore(),
      isLoading: false,
      step: 0,
      stepData: [
        {
          id: 1,
          position: 0,
          component: markRaw(UebungActivitasCreateIntroduction),
          title: 'Erklärung der Übung',
        },
        {
          id: 2,
          position: 1,
          component: markRaw(LemmaComposer),
          title: 'Wortschatzauswahl',
          isOptional: false,
          hasNextStepCondition: true
        },
        {
          id: 3,
          position: 2,
          component: markRaw(UebungActivitasCreateConfig),
          title: 'Konfiguration',
          isOptional: false,
          hasNextStepCondition: true
        },
        {
          id: 4,
          position: 3,
          component: markRaw(UebungActivitasCreateSubmit),
          title: 'Speichern',
          isOptional: false
        },
      ]
    }
  },
  methods: {


  },
  mounted() {
    EventBus.$on('update:latin-lemma-collection', (latin_lemma_collection) => {
      this.store.setLatinLemmaCollection(latin_lemma_collection);
    });
    
    EventBus.$on('WordDeleted', word => {
      this.remove(word);
    });
    
    EventBus.$on('WordActivityChanged', ItemObject => {
      this.changeActivity(ItemObject);
    });

  }
}
</script>

<style scoped></style>